// src/features/oio/errors/components/ErrorToast.tsx
import { RotateCcw, X } from "lucide-react"
import { Button } from "@/components/ui/button"

interface ErrorToastProps {
  message: string
  onRetry?: () => void
  onDismiss: () => void
}

export function ErrorToast({ message, onRetry, onDismiss }: ErrorToastProps) {
  return (
    <div className="fixed bottom-4 right-4 z-50 w-80 rounded-lg border border-orange-300 bg-orange-50 px-4 py-3 shadow-lg">
      <div className="flex items-start gap-2">
        <div className="flex-1">
          <p className="text-xs font-medium text-orange-800">{message}</p>
        </div>
        <button onClick={onDismiss} aria-label="Dismiss">
          <X className="h-3.5 w-3.5 text-orange-600 opacity-60 hover:opacity-100" />
        </button>
      </div>
      {onRetry && (
        <Button
          variant="outline"
          size="sm"
          className="mt-2 w-full gap-1.5 border-orange-300 text-xs text-orange-700 hover:bg-orange-100"
          onClick={onRetry}
        >
          <RotateCcw className="h-3 w-3" />
          Try again
        </Button>
      )}
    </div>
  )
}
